(function (app, ng) {

    app.config([
        "figModalStateProvider", function (figModalStateProvider) {
            figModalStateProvider.state("Home.ManageStockQuestions.NewStockQuestion",
                {
                    url: "/NewStockQuestion",
                    component: "newStockQuestion"
                });
        }
    ]);

    app.component("newStockQuestion",
        {
            controller: newStockQuestionController,
            templateUrl: "/App/Dashboard/ManageStockQuestions/NewStockQuestion/template.html"
        });

    newStockQuestionController.$inject = ["$state", "$mdDialog", "stockQuestionApi", "$q"];

    function newStockQuestionController($state, $mdDialog, stockQuestionApi, $q) { 
        var $ctrl = this;

        ng.extend($ctrl,
            {
                UI: {},
                close: close,
                save: save,
                question: {
                    StockQuestionPossibleAnswers: []
                }
            });

        function close() {
            $ctrl.UI.isClosing = true;
            $mdDialog.hide().then(function () { $ctrl.UI.isClosing = false; });
        }

        function save() {
            if ($ctrl.question.QuestionText.length && $ctrl.question.Type) {
                $ctrl.UI.isSaving = true;
                if ($ctrl.question.Type === "LongText" || $ctrl.question.Type === "ShortText")
                    $ctrl.PossibleAnswers = null;
                stockQuestionApi.createStockQuestion($ctrl.question).then(function (data) {
                    var promises = [];
                    promises.push(stockQuestionApi.createFirelightQuestion({ StockQuestionId: data.Id, tag: null }));
                    //TODO: Remove when rightbridge is 100% gone
                    //promises.push(stockQuestionApi.createRightBridgeQuestion({ StockQuestionId: data.Id, tag: null }));
                    return $q.all(promises).then(function (d) {
                        return $state.go("^", {}, { reload: true });
                    });
                });
            }
        }
    }

})(window.app, window.angular); //jshint ignore:line